<template>
  <div id="checkingPlot">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>陰謀カードの取得</b></p>

    <div class="checking-plot-area">
      <div v-if="isLeader">
        <div v-if="!sent">
          <p>以下の陰謀カードを引きました．<br>リーダーはボタンを押してゲームを進めて下さい．</p>
          <div class="plot-table">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="plot in drawnPlots" :key="plot.id">
                    <td v-on:click="showEffect(plot)" style="background-color:#f6f6fa"><span class="plot-name" style="font-size:16px;"><b><u>{{ plot.name }}</u></b></span></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="send-button">
            <sendButton v-on:pushed="push" label="進める" active="true"/>
          </div>
        </div>
        <div v-else>
          <span>ゲーム情報を取得しています．</span>
        </div>
      </div>
      <div v-else>
        <p>リーダー({{leader.name}})が陰謀カードを引いています。</p>
      </div>
    </div>
  </v-card>
  </div>
</template>

<script>
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "checkingPlot",
  plops: [],
  components: {
    sendButton
  },
  data() {
    return {
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      sent: false,
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    round () {
      return this.$store.state.missionInfo.round
    },
    isLeader: function() {
      // return true
      return this.$store.getters.isLeader;
    },
    drawnPlots : function() {
      return this.$store.getters.getDrawnPlots(this.$store.state.missionInfo.round)
    },
  },
  methods: {
    checkingPlot: function() {
      var event = {};
      event.name = "checkingPlot";
      event.target = null;
      this.$emit("next", event);
    },
    push(){
      // this.sent = true
      this.$emit("send-request", {"action": "checked-plots", "roomId": this.roomId, "userId": this.userId, data: {}})
    },
    showEffect: function(plot){
      console.log(plot)
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
  },
  created() {
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      // "wait-trust" or "assigning-plots"
      console.log(self.drawnPlots)

      var snackText = ""
      var nextState = "wait-trust"
      if (res.state == "wait-trust"){
        // 信用の確立を引いたカードから削除
        self.$store.commit('deleteDrawnPlot', {'round': self.round, 'plotId': 8})
        for (var plot1 of self.drawnPlots){
          snackText += " "
          snackText += plot1.name

          if (plot1.id == 8){
            self.$store.commit('setPlots', {"plotId": 8, "userId": self.leader.id})
          }
        }
        snackText += "を引きました．"
        self.$emit("show-text", {state: "checking-plots-assigning-plots", text: snackText})
        nextState = "waitTrust"
      }else if (res.state == "assigning-plots"){
        for (var plot2 of self.drawnPlots){
          snackText += " "
          snackText += plot2.name
        }
        snackText += "を引きました．"
        self.$emit("show-text", {state: "checking-plots-assigning-plots", text: snackText})
        nextState = "assigningPlots"
      }else if (res.state == "assigning-mission"){
        nextState = "assigningMission"
      }

      // if (self.drawnPlots.filter(plot => plot.id==5).length>0){
      //   var plotUser = self.users.filter(user => user.plots.length>0)
      //   if (plotUser.length == 0){
      //     self.$store.commit('deleteDrawnPlot', {'round': self.round, 'plotId': 5})
      //     self.$emit("show-text", {state: "checking-plots", text: "責任者は使用できないため破棄されました．"})
      //     nextState = "assigningMission"
      //   }
      // }

      self.$emit("proceed-state", nextState)
    }
  }
};
</script>

<style>
#checkingPlot {
  /* background-color: rgb(193, 255, 255); */
}
#checkingPlot .send-button {
  padding-bottom: 12px;
}
#checkingPlot .plot-table {
  align-items: center;
  display: inline-block;
  text-align:center;
  min-width: 200px;
  margin-bottom: 12px;
}
#checkingPlot .plot-name {
  color: #5555BB;
  cursor:pointer ;
}
#checkingPlot td{
  border-bottom: 0px;
}
</style>
